import { useFormField } from '@calendly/form';
import { TagText } from '@calendly/tags';
import { FullStoryExclude } from '@calendly/ui/components/fullstory-privacy';
import classNames from 'classnames';
import { useCallback, forwardRef } from 'react';
import { isEnterKey } from 'services/keycodes';
import { DELIMITER_CHARS } from '../../../constants';
const emailInputCss = "e1pb9408";
const EmailInput = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'input';
  return <Component ref={ref} {...restProps} className={classNames(emailInputCss, props.className)} />;
});
export const EditView = ({
  name,
  toggleView
}) => {
  const [fieldProps] = useFormField({
    name
  });
  const handleKeyDown = useCallback(event => {
    if (isEnterKey(event)) toggleView();
  }, [toggleView]);
  const handleFocus = useCallback(({
    target
  }) => {
    target.select();
  }, []);
  const handleBlur = useCallback(() => {
    toggleView();
  }, [toggleView]);
  const handleBeforeInput = useCallback(event => {
    if (DELIMITER_CHARS.indexOf(event.data) > -1) {
      event.preventDefault();
      toggleView();
    }
  }, [toggleView]);
  const handleMouseDown = useCallback(event => {
    event.stopPropagation();
  }, []);
  return <>
      <TagText>{fieldProps.value}</TagText>
      <FullStoryExclude>
        <EmailInput {...fieldProps} autoFocus type="email" spellCheck={false} onBlur={handleBlur} onMouseDown={handleMouseDown} onKeyDown={handleKeyDown} onFocus={handleFocus} onBeforeInput={handleBeforeInput} />
      </FullStoryExclude>
    </>;
};

require("./edit_view.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./edit_view.js");